import { Injectable, inject } from '@angular/core';

import { Widget, WidgetContext } from '@frontend/sports/types/components/widget';
import { Observable } from 'rxjs';

import { WidgetContextService } from './widget-context.service';

@Injectable({
    providedIn: 'root',
})
export class WidgetContextRefreshProcessor {
    private context = inject(WidgetContextService);

    refresh(contexts: Partial<WidgetContext>[]): Observable<Widget<unknown>[] | undefined> {
        return this.context.getWidgetBatch(contexts);
    }
}
